import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "loading",
  id: "loading"
}
const _hoisted_2 = { class: "load_box" }

import { Ref } from 'vue'
import { Loading } from 'vant'


export default /*@__PURE__*/_defineComponent({
  __name: 'Loading',
  props: {
    show: {},
    message: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(Loading), {
        color: "#666",
        size: "40px",
        class: "van-loading-box"
      }),
      _createElementVNode("span", null, _toDisplayString(__props.message.value), 1)
    ])
  ], 512)), [
    [_vShow, __props.show.value]
  ])
}
}

})